/*eslint-disable*/
import { CancelBtn } from 'components/Button/CancelBtn'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { Input } from 'components/Input/Input'
import { ItemsPick } from 'components/ItemsPick/ItemsPick'
import { Spinner } from 'components/Loading/Loading'
import { NavBar } from 'components/NavBar/NavBar'
import { INameId, ISelectValue } from 'constants/globalTypes'
import { clearGenerated, confirmTask, confirmWorkflow } from 'features/tasks/tasksSlice'
import { clearInputComponents, getInputComponents } from 'features/taskTemplates/taskTemplatesSlice'
import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { AppDispatch, RootState } from 'store'
import {
    Animation,
    Button,
    ButtonsContainer,
    ContentWrapper,
    Flex,
    H1WithBack,
    ItemsPickContainer,
    PageFooter,
    PageWrapper,
    SelectedItemsContainer,
    Separator,
    Tabs,
    TabsContainer,
    Title,
} from 'styling/GlobalStyles'
import { IDepartmentForTask, IDepartmentForTaskWithTypes } from 'types/api/tasksApi.interface'
import { ITaskInputComponentsResponse } from 'types/api/tasksTemplatesApi.interface'
import { IAddTaskState } from 'types/tasks.interface'
import { setState, toLocalDateTime } from 'utils/helpers'
import { TaskSection } from './sections/TaskSection'
import { getSingleWorkflowTemplateForCompany } from 'features/workflows/workflowsSlice'
import { WorkflowSection } from './sections/WorkflowSection'
import { IWorkflowTemplateForCompanyResponse } from 'types/api/workflowsAPi.interface'
import CalendarInput from 'components/CalendarInput/CalendarInput'

export const AddTask = () => {
    const [config, setConfig] = useState<IAddTaskState>({
        task: null,
        location: null,
        department: null,
        machine: null,
        item: null,
        date: new Date(),
        criteria: null,
        components: [],
        items: [],
    })
    const [locations, setLocations] = useState<ISelectValue[]>([])
    const [tab, setTab] = useState<'task' | 'workflow'>('task')

    const configRef = useRef(null)
    const dispatch = useDispatch<AppDispatch>()
    const { isLoadingGenerate, generatedTask, generatedWorkflow } = useSelector((state: RootState) => state.tasks)
    const navigate = useNavigate()

    useEffect(() => {
        return () => {
            dispatch(clearInputComponents())
            dispatch(clearGenerated())
        }
    }, [])

    const handleAdd = (e: INameId) => {

        if (tab == 'task') {
            dispatch(clearInputComponents())
            getTaskTemplateComponents(e.id.toString())

        } else {
            getWorkflowDetails(e.id.toString())

        }
        dispatch(clearInputComponents())
        dispatch(clearGenerated())
        setConfig({
            task: { label: e.name, value: e.id, type: tab },
            department: null,
            location: null,
            machine: null,
            item: null,
            date: new Date(),
            criteria: null,
            components: [],
            items: [],
        })

        //   setLocations(e.locations.map((l) => ({ label: l.name, value: l.id })))
    }

    const handleChange = (value: ISelectValue, name: string) => {
        if (name == 'task') {
            dispatch(clearInputComponents())
            if (!value.value) {
                const v = { label: '', value: null, type: null }
                setState(setConfig, name, v)
                return
            }
            // TODO Napraviti dobar interfejs za string u value selecta
            //@ts-ignore
            const s = (value.value as string).split('-')
            if (s[1] == 'task') {
                getTaskTemplateComponents(s[0])
            } else if (s[1] == 'workflow') {
                getWorkflowDetails(s[0])
            }
            const v = { label: value.label, value: Number(s[0]), type: s[1] }
            setState(setConfig, name, v)
        } else {
            setState(setConfig, name, value)
        }
    }

    const getTaskTemplateComponents = async (id: string) => {
        const resp = await dispatch(getInputComponents(id))
        setConfig((prev) => ({
            ...prev,
            components: (resp.payload as ITaskInputComponentsResponse).taskTemplate?.components.map(
                (c) => ({ name: c.name, value: null, id: c.id }),
            ),
        }))
    }

    const getWorkflowDetails = async (id: string) => {
        const resp = await dispatch(getSingleWorkflowTemplateForCompany(id))
        setConfig((prev) => ({
            ...prev,
            items: (resp.payload as IWorkflowTemplateForCompanyResponse)?.items?.map((i) => {
                const machine = i.taskTemplate.toolTypeComponents.find(c => c.toolTypeComponent.name == 'Machinery')
                const item = i.taskTemplate.toolTypeComponents.find(c => c.toolTypeComponent.name == 'Item')
                return {
                    workflowTemplateItemId: i.id,
                    location: prev.location,
                    components: i.taskTemplate.components.map((c) => ({
                        name: c.name,
                        id: c.id,
                        value: null,
                        componentType: c.componentType,
                    })),
                    machine: !machine ? null : { label: machine.name, value: null, taskTemplateToolTypeComponentId: machine.id },
                    item: !item ? null : { label: item.name, value: null, taskTemplateToolTypeComponentId: item.id, amount: null },
                    name: i.taskTemplate.name,
                    id: i.id
                }
            }),
            // components: (resp.payload as IWorkflowTemplateForCompanyResponse).taskTemplate?.components.map(
            //     (c) => ({ name: c.name, value: null, id: c.id }),
            // ),
        }))
    }

    const parseToolComponents = (r) => {
        return r.data.map((m) => ({ value: m.id, label: m.name }))
    }


    const handleConfirm = async () => {
        if (config.task.type == 'task') {
            await dispatch(confirmTask(generatedTask.task.id))
            navigate('/dashboard/tasks/' + generatedTask.task.id + '?fromTasks=true')
        } else {
            await dispatch(confirmWorkflow(generatedWorkflow.id))
            navigate('/dashboard/tasks/' + generatedWorkflow.items[0].task.id + '?fromTasks=true')
        }

    }


    return (
        <PageWrapper>
            <NavBar />
            <Flex width='100%' between mb='16'>
                <H1WithBack arrow title='Add Task' />
                <TabsContainer>
                    <Tabs onClick={() => setTab('task')} active={tab == 'task'} >Task Templatess</Tabs>
                    <Tabs onClick={() => setTab('workflow')} active={tab == 'workflow'} >Workflow Templates</Tabs>
                </TabsContainer>
            </Flex>
            <ContentWrapper>
                <Spinner inElement={true} loading={isLoadingGenerate} />
                <Animation>
                    <ItemsPickContainer>
                        <SelectedItemsContainer ref={configRef}>
                            <Title pad='0'>Configure Task</Title>
                            {config?.task?.value && (
                                <Flex column gap='1rem'>
                                    <CalendarInput
                                        labelText='Start date'
                                        name='date'
                                        onChange={(v) => setState(setConfig, 'date', v)}
                                        defaultValue={toLocalDateTime(config.date)}
                                    />

                                    {config.task?.type == 'task' && (
                                        <TaskSection
                                            handleChange={handleChange}
                                            config={config}
                                            setConfig={setConfig}
                                            configRef={configRef}
                                            parseToolComponents={parseToolComponents}
                                        />
                                    )}
                                    {config.task?.type == 'workflow' && (
                                        <WorkflowSection
                                            setConfig={setConfig}
                                            locations={locations}
                                            handleChange={handleChange}
                                            config={config}
                                            configRef={configRef}
                                            parseToolComponents={parseToolComponents}
                                        />
                                    )}
                                </Flex>
                            )}
                        </SelectedItemsContainer>
                        <ItemsPick
                            width='100%'
                            handleAdd={handleAdd}
                            link={tab == 'task' ? 'task/template/overviews' : 'workflow/template'}
                            selectedList={[config?.task?.value ? { name: config?.task?.label, id: config?.task?.value } : null]}
                            placeholder={tab == 'task' ? 'Search tasks' : 'Search workflows'}
                        />
                    </ItemsPickContainer>
                </Animation>
            </ContentWrapper>
            <PageFooter>
                <ButtonsContainer>
                    <CancelBtn />
                    {((config.task?.type == 'task' && generatedTask) || (config.task?.type == 'workflow' && generatedWorkflow)) && (
                        <Button orange onClick={handleConfirm}>
                            Confirm {config.task?.type}
                        </Button>
                    )}
                </ButtonsContainer>
            </PageFooter>
        </PageWrapper>
    )
}
